import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface StreamingState {
  privateRequests: any[];
}

const initialState: StreamingState = {
  privateRequests: []
};

const streamingSlice = createSlice({
  name: 'streaming',
  initialState,
  reducers: {
    addPrivateRequest(state, action: PayloadAction<any>) {
      state.privateRequests.push(action.payload);
    },
    accessPrivateRequest(state, action: PayloadAction<string>) {
      state.privateRequests = state.privateRequests.filter(
        (p) => p.conversationId !== action.payload
      );
    },
    resetPrivateRequests(state) {
      state.privateRequests = [];
    }
  }
});

export const {
  addPrivateRequest,
  accessPrivateRequest,
  resetPrivateRequests
} = streamingSlice.actions;

export default streamingSlice.reducer;